import Footer from "./sub-components/Footer";
import Header from "./sub-components/Header";
import "../../styles/globals.css";
const BuyCouponCode = () => {
    return (
        <div className="main-site bcc-parent-container">
            <div className="hero-container-2">
                <Header />
                <div className="overlay"></div>
                <div className="hero-text">
                    <h1>Buy Coupon Code</h1>
                </div>
            </div>
            <div className="bcc-main-container">
                <p>To get your Coupon Code, Kindly contact(Call or Whatsapp) any of our Pin dispactchers below</p>

                <div className="dispatchers">
                    <div className="dispatcher-wrapper">
                        <div className="container">
                            {/* <div className="dispatcher flex space-around header">
                                <strong>Serial No</strong>
                                <strong>Name</strong>
                                <strong>Mobile</strong>
                                <strong>Whatsapp</strong>
                                <strong>Call</strong>
                            </div> */}
                            <div className="dispatcher flex space-around">
                                <strong>1</strong>
                                <strong>BLESSED CHILD</strong>
                                <strong>09026510883</strong>
                                <a href="https://wa.link/q9rarj"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:09026510883"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>2</strong>
                                <strong>Born to Win</strong>
                                <strong>+2349043038626</strong>
                                <a href="https://wa.me/message/M7E2LMDO5ORNJ1"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2349043038626"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>3</strong>
                                <strong>SULAIMAN OLATECH </strong>
                                <strong>09064663896</strong>
                                <a href="https://wa.me/+2349064663896"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:09064663896"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>4</strong>
                                <strong> SimplyMe</strong>
                                <strong>09095335287</strong>
                                <a href="https://bit.ly/3zDJBaX"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:09095335287"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>5</strong>
                                <strong>Omo-Tee</strong>
                                <strong>07038347879</strong>
                                <a href="https://bit.ly/Omotee01"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:07038347879"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>6</strong>
                                <strong>Skyprince</strong>
                                <strong>08068351397</strong>
                                <a href="https://wa.link/m35p5y"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:08068351397"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>7</strong>
                                <strong>Richard</strong>
                                <strong>08055824818</strong>
                                <a href="https://wa.me/message/OFSIQOK3XDBEE1"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:08055824818"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>8</strong>
                                <strong>Hilltop Tv</strong>
                                <strong>09037565694</strong>
                                <a href="https://wa.me/+2349037565694"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:09037565694"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>9</strong>
                                <strong>STEPHINE</strong>
                                <strong>08118359691</strong>
                                <a href="https://wa.me/message/25WMPX3NAT23K1"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:08118359691"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>10</strong>
                                <strong>Micky_Krain</strong>
                                <strong>07010287259</strong>
                                <a href="https://wa.me/qr/BHURKEXNCIVMJ1"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:07010287259"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>11</strong>
                                <strong>MERCIFUL TV</strong>
                                <strong>09073871245</strong>
                                <a href="https://bit.ly/3sXxhkC"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:09073871245"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>12</strong>
                                <strong>Oshe</strong>
                                <strong>07012614525</strong>
                                <a href="https://bit.ly/3GdIGjO"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:07012614525"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>13</strong>
                                <strong>teamSuccessTV</strong>
                                <strong>07019410412</strong>
                                <a href="https://wa.me/2347019410412"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:07019410412"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>14</strong>
                                <strong>Marvellous Ukoh</strong>
                                <strong>09070045260</strong>
                                <a href="https://wa.link/fx70ot"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:09070045260"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>15</strong>
                                <strong>Kalu Grace</strong>
                                <strong>+2347063716303</strong>
                                <a href="https://wa.me/+2347063716303"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2347063716303"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>16</strong>
                                <strong>Coach</strong>
                                <strong>+2348133614906</strong>
                                <a href="https://wa.link/1k83ke"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2348133614906"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>17</strong>
                                <strong>CHARITY EZINNE</strong>
                                <strong>+2348160028387</strong>
                                <a href="http://bit.ly/4DGsGEO"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2348160028387"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>18</strong>
                                <strong>Nelson</strong>
                                <strong>+2348064587253</strong>
                                <a href="https://wa.me/+2348064587253"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2348064587253"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>19</strong>
                                <strong>Glogreen</strong>
                                <strong>+2348144770053</strong>
                                <a href="https://wa.me/2348144770053"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2348144770053"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>20</strong>
                                <strong>Grace (Bosslady)</strong>
                                <strong>+2348034256947</strong>
                                <a href="https://bit.ly/3JKgDuR"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2348034256947"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>21</strong>
                                <strong>Wannyplug</strong>
                                <strong>+2349030543591</strong>
                                <a href="https://bit.ly/3HGW3cH"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2349030543591"><i class="ri-phone-fill"></i></a>
                            </div>
                            <div className="dispatcher flex space-around">
                                <strong>22</strong>
                                <strong>ADAEZEJESUS</strong>
                                <strong>+2348125629352</strong>
                                <a href="https://bit.ly/34iuCHO"><i class="ri-whatsapp-fill"></i></a>
                                <a href="tel:+2348125629352"><i class="ri-phone-fill"></i></a>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <Footer />
        </div>
    );
}

export default BuyCouponCode;
